// Converts query information into a friendly operation object
export const getGraphqlOperation = ({ query = {}, variables }) => {
  return {
    query: query.loc && query.loc.source.body,
    variables,
  };
};
